import { createBrowserHistory } from "history";
import { Modal } from "m-ui";

const history = createBrowserHistory({
  getUserConfirmation(message, callback) {
    Modal.confirm({
      title: "您修改的内容未保存，确定离开吗？",
      content: message || "离开后，修改的内容不生效",
      okText: "离开",
      cancelText: "取消",
      onOk() {
        callback(true);
      },
      onCancel() {
        callback(false);
      },
    });
  },
});
export default history;
